import api from 'api';
import Cookies from 'portal-cookie';
import getResponseErrors from 'lib/getResponseErrors';
import { actions as permissionActions } from './permissions.redux';
import { notification } from 'antd';
import { forEach } from 'lodash';

const fakePermissions =
{
	'admin_manage_services': true,
	'admin_permissions_read': true,
	'admin_permissions_write': true,
	'admin_show_menu': true,
	'admin_user_groups_read': true,
	'admin_user_groups_write': true,
	'admin_user_management_read': true,
	'admin_user_management_write': true,
	'admin_user_data_read': true,
	'admin_user_data_write': true,
	'superadmin': true,
	'user_details_change_password': true,
	'business_partner_read': true,
	'business_partner_write': true,
	'bp_contact_read': true,
	'bp_contact_write': true,
	'bp_address_read': true,
	'bp_address_write': true,
	'configurator_view_menu': true,
	'configurator_models_read': true,
	'configurator_models_write': true,
	'configurator_model_definitions_read': true,
	'configurator_model_definitions_write': true,
	'configurator_properties_read': true,
	'configurator_properties_write': true,
	'configurator_option_sets_read': true,
	'configurator_option_sets_write': true,
	'orders_view_menu': true,
	'orders_read': true,
	'orders_admin': true,
	'orders_write': true

}

const initialState = {
	loggedIn: false,
	pending: false,
	sessionId: null,
	systemsRequested: false,
	accessibleSystems: [],
	userDataArray: [],
	selectedSystem: null,
	showRelog: false,
	errors: [],
	resetToken: null,
	verifyingToken: false,
	showSignupModal: false,
};


export const types = {
	SET_STATE: 'AUTH/SET_STATE',
};

// const forceReset = (systems, userData) => {
// keeping this because it might be useful
// 	//console.log('forceReset')
// 	//console.log('userData', userData)
// 	//console.log('systems', systems)
// 	let reset = false;
// 	systems.forEach((system) => {
// 		//console.log('system', system)
// 		reset = Boolean(userData?.[0]?.[system]?.reset_password)
// 	})
// 	//console.log('forceReset', reset)
// 	return Boolean(reset)
// }

const getTokenFrom = (userData) => {
	console.log('getTokenFrom')
	const token = userData?.[0] && Object.values(userData[0])[0]?.token;
	return token;
}

const reducers = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		default:
			return state;
	}
};

export default reducers;



export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

	// Full reset for a forced logout (expired or invalid token). Only setting
	// loggedIn: false leaves selectedSystem and the fetched-systems state
	// behind, which renders the login form mid-flow (password showing, no
	// company select) until a refresh.
	forceLogout: (errors) => ({
		type: types.SET_STATE,
		data: {
			...initialState,
			// not part of initialState, clear it explicitly
			showPasswordChange: false,
			errors: errors || [],
		},
	}),

	heartbeat: (data) => async (dispatch, getState) => {
		console.log('[auth.redux] heartbeat');
		try {
			let heartbeat = await api.get('/heartbeat/heartbeat');

			// console.log(heartbeat);
			// console.log(heartbeat.alive);

			if (heartbeat && heartbeat.alive) {
				console.log('SUCCESS service is alive');
				notification.destroy();
				notification['success']({
					duration: 1,
					title: 'Account Service connection: ',
					description:
						'Established',
				});
			} else {
				throw ('Service is not reachable');
			}

		} catch (err) {
			console.error('service is NOT alive');
			console.error(err);
			notification.destroy();
			notification['error']({
				duration: 10,
				title: 'Error: Service is not reachable',
				description:
					'Contact your IT or System Admin',
			});
		}
	},


	getSystems: (email) => async (dispatch, getState) => {

		console.log('getSystems', email);

		dispatch({ type: types.SET_STATE, data: { pending: true, errors: [] } });

		try {
			// TODO take the email, check all 3 systems and get the systems they can login to
			let res = await api.get('/user/system', {
				params: {
					user: email,
				}
			});

			console.log(res)
			// console.log(res.accessibleSystems)
			// console.log(res.userDataArray)
			// console.log(getTokenFrom(res.userDataArray))

			dispatch(permissionActions.setState(fakePermissions || {})); // TODO MULTISAP_FAKE_PERMS
			dispatch({
				type: types.SET_STATE,
				data: {
					systemsRequested: true,
					accessibleSystems: res.accessibleSystems,
					userDataArray: res.userDataArray,
					//pending: false,
				},
			});
			//Cookies.set('authToken', getTokenFrom(res.userDataArray));


		} catch (err) {
			console.log(err)
			dispatch({ type: types.SET_STATE, data: { pending: false, errors: getResponseErrors(err) } });
		}
	},

	chooseSystem: (system) => async (dispatch, getState) => {
		console.log('chooseSystem', system);
		dispatch({ type: types.SET_STATE, data: { pending: true, errors: [] } });
		try {

			Cookies.set('LastSystem', system);

			dispatch({
				type: types.SET_STATE, data:
				{
					//...initialState,
					//loggedIn: true,
					selectedSystem: system,
					pending: false
				}
			});
		} catch (err) {
			console.log(err)
		}
	},


	handleLogin: (data) => async (dispatch, getState) => {
		console.log('handleLogin')
		console.log(data)
		dispatch({ type: types.SET_STATE, data: { pending: true, errors: [] } });

		let { selectedSystem } = getState().auth;
		console.log('selectedSystem', selectedSystem);


		try {
			let res = await api.post('/user/login', {
				user: data.username,
				pass: data.password,
				system: selectedSystem
			});

			if (res.reset_password) {
				dispatch({
					type: types.SET_STATE,
					data: {
						pending: false,
						errors: [],
						loggedIn: false,
						showPasswordChange: true,
						resetToken: res.token,
					},
				});
			} else {
				dispatch(permissionActions.setState(res.permissions || {}));
				dispatch({ type: types.SET_STATE, data: { ...initialState, loggedIn: true, selectedSystem: selectedSystem, sessionId: res.sessionId } });
				Cookies.set('authToken', res.token);
			}

		} catch (err) {
			dispatch({ type: types.SET_STATE, data: { pending: false, errors: getResponseErrors(err) } });
		}
	},

	handleLogout: () => async (dispatch, getState) => {
		console.log('handleLogout')
		dispatch({ type: types.SET_STATE, data: { pending: true, errors: [] } });

		let { selectedSystem, sessionId } = getState().auth;
		console.log('selectedSystem', selectedSystem);
		console.log('sessionId', sessionId);

		try {
			let res = await api.post('/user/logout', {
				sessionId: sessionId,
				system: selectedSystem
			});

			console.log(res);
			dispatch({ type: types.SET_STATE, data: { ...initialState } });
			Cookies.remove('authToken');
			Cookies.remove('LastSystem');


		} catch (err) {
			dispatch({ type: types.SET_STATE, data: { pending: false, errors: getResponseErrors(err) } });
		}
	},


	handlePasswordChange: (data) => async (dispatch, getState) => {
		console.log('[auth.redux] handlePasswordChange')
		//console.log(data)
		dispatch({ type: types.SET_STATE, data: { pending: true, errors: [] } });

		if (data.resetPassword1 !== data.resetPassword2) {
			return dispatch({
				type: types.SET_STATE,
				data: { pending: false, errors: ['Password fields must match.'] },
			});
		}

		try {
			let chgPw = await api.post('/user/change_password', {
				token: getState().auth.resetToken,
				pass: data.resetPassword1,
			});
			//console.log(chgPw);

			dispatch({
				type: types.SET_STATE,
				data: {
					pending: false,
					errors: [],
					loggedIn: false,
					showPasswordChange: false,
					showRelog: true,
					resetToken: null,
				},
			});


		} catch (err) {
			dispatch({ type: types.SET_STATE, data: { pending: false, errors: getResponseErrors(err) } });
		}
	},



	verifyToken_OG: () => async (dispatch) => {
		console.log('[auth.redux] verifyToken')

		// BUG if the token expires, the new flow doesnt reissue the token and you cant login
		// have to replace the Login component, login, then flip back
		dispatch({ type: types.SET_STATE, data: { pending: true, loggedIn: false, verifyingToken: true, errors: [] } });

		try {
			let res = await api.get('/user/verify_token', {
				params: {
					system: 'NO_SYS' // TODO extract from something
				}
			});

			console.log(res);

			dispatch(permissionActions.setState(fakePermissions || {})); // TODO MULTISAP_FAKE_PERMS
			dispatch({
				type: types.SET_STATE,
				data: {
					...initialState,
					loggedIn: true,
					verifyingToken: false,
				},
			});

		} catch (err) {
			console.log('[auth.redux] verifyToken catch err', err)
			dispatch({
				type: types.SET_STATE,
				data: { verifyingToken: false, pending: false, errors: getResponseErrors(err) },
			});
			Cookies.remove('authToken');
		}
	},

	verifyToken: () => async (dispatch, getState) => {
		console.log('[auth.redux] verifyToken')

		//const state = getState();
		let { selectedSystem } = getState().auth;
		console.log('selectedSystem', selectedSystem);

		let LastSystem = Cookies.get('LastSystem');
		console.log('LastSystem', LastSystem)

		dispatch({
			type: types.SET_STATE, data: {
				pending: true,
				//loggedIn: false,
				verifyingToken: true,
				errors: []
			}
		});

		try {
			let res = await api.get('/user/verify_token', {
				params: {
					system: selectedSystem ?? LastSystem
				}
			});

			console.log(res);

			dispatch(permissionActions.setState(fakePermissions || {})); // TODO MULTISAP_FAKE_PERMS
			dispatch({
				type: types.SET_STATE,
				data: {
					//...initialState,
					loggedIn: true, // BUG refresh doesnt log back in with this disabled
					pending: false,
					verifyingToken: false,
				},
			});

		} catch (err) {
			console.log('[auth.redux] verifyToken catch err', err)
			dispatch({
				type: types.SET_STATE,
				data: { verifyingToken: false, pending: false, errors: getResponseErrors(err) },
			});
			Cookies.remove('authToken');
			Cookies.remove('LastSystem');

		}
	},
};
